export default import.meta.ROLLDOWN_FILE_URL_JnXXzd$0isqcT1bupm3T6Q